import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/mapaIN/step4';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {

  private LOG: LogService = new LogService(Step4Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	

	@Input() uid = '';


	public step4 = new Step4();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {
  }

  public getUid() {
		return this.uid;
	}

}
